import { AppState } from '../store'
import { OrganizationsState } from '../reducers/organizations'

export const organizationsSelector = (state: AppState): OrganizationsState => {
  return state && state.organizations
}
